// define default data structure for entire user model here
// these defaults are applied in subclasses of module/user/user
// objects can listen to any part of an unfetched user and react to changes
// any nested models should be represented here as {}
// any nested collections should be represented here as []
// individual properties at any level should be left undefined
// default values are defined in node/python, not here
const color_swatches = require('data/color_swatches')

const UserDefaults = {
    user_name: '',
    first_name: '',
    last_name: '',
    contact_me: {
        id: 'contact_me',
    },
    tags: [],
    interests: [],
    roles: [],
    locations: [],
    schools: [],
    jobs: [],
    apps: [],
    links: [],
    images: [],
    portfolio: [],
    allowed_features: [], // just an array of strings, not a related list
    contact: {
        id: 'contact',
    },
    spotlight: {
        id: 'spotlight',
    },
    spotlight_trial: {
        id: 'spotlight_trial',
    },
    testimonials: {
        id: 'testimonials',
        header: '0',
        items: [],
    },
    layout: {
        version: 1,
        id: 'layout',
        color: color_swatches[0].swatch,
    },
    slack_teams: [],
    counters: {
        id: 'counters',
    },
    actions: {
        id: 'actions',
    },
    flags: {
        id: 'flags',
    },
    settings: {
        id: 'settings',
        compliments: {
            id: 'compliments',
        },
        follow: {
            id: 'follow',
        },
        share: {
            id: 'share',
        },
    },
    store: {
        id: 'store',
        credit_card: {
            id: 'credit_card',
        },
        charges: [],
        purchases: [],
    },
    mapped_domains: [],
    email_channels: {
        id: 'email_channels',
    },
    video: {
        id: 'video',
    },
}

module.exports = UserDefaults
